"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Label_1 = __importDefault(require("@modules/Label"));
const objectUtils_1 = __importDefault(require("@utils/objectUtils"));
const react_1 = __importDefault(require("react"));
require("./style.scss");
const InputLabel = (props) => {
    var _a, _b;
    const { name, label, className = '', onClick, onChange, onBlur, onComposition, type = 'text', placeholder = '', message = '', disabled = false, readonly = false, defaultValue, value, required = false, register, maxLength, minLength, messages, pattern, validate, dataIndex, minValue, isShowIntervalMark = false } = props;
    const [keyword, setKeyword] = react_1.default.useState('');
    const [isOnComposition, setIsOnComposition] = react_1.default.useState(false);
    const handleOnClick = (event) => {
        if (onClick)
            onClick(event);
    };
    const handleOnChange = (event) => {
        if (readonly || disabled)
            return;
        setKeyword(event.target.value);
        if (onChange)
            onChange(event);
    };
    const handleComposition = (event) => {
        if (readonly || disabled)
            return;
        if (event.type === 'compositionend') {
            setKeyword(event.target.value);
            setIsOnComposition(false);
        }
        else
            setIsOnComposition(true);
    };
    const handleOnBlur = (event) => {
        if (readonly || disabled)
            return;
        if (onBlur)
            onBlur(event);
    };
    react_1.default.useEffect(() => {
        if (!isOnComposition && objectUtils_1.default.isExist(onComposition)) {
            const getComposition = onComposition();
            if (!objectUtils_1.default.isExist(getComposition))
                return;
            getComposition(keyword);
        }
    }, [keyword, isOnComposition]);
    const getHandlerBinding = () => (register ? getRegisterRefAndRest() : getOnBlurHandler());
    /**
     *  未使用hook-form register但props有自定義onBlur事件
     * @returns
     */
    const getOnBlurHandler = () => {
        return {
            registerRef: null,
            rest: {
                onBlur: handleOnBlur
            }
        };
    };
    /**
     * 處理綁定hook-form register
     * @returns
     */
    const getRegisterRefAndRest = () => {
        var _a, _b, _c, _d;
        const requiredField = required ? { required: (_a = messages === null || messages === void 0 ? void 0 : messages.required) !== null && _a !== void 0 ? _a : '' } : null;
        const validateField = validate && { validate };
        const patternField = pattern && { pattern: { value: pattern, message: (_b = messages === null || messages === void 0 ? void 0 : messages.pattern) !== null && _b !== void 0 ? _b : '' } };
        const maxLengthField = maxLength && { maxLength: { value: maxLength, message: (_c = messages === null || messages === void 0 ? void 0 : messages.maxLength) !== null && _c !== void 0 ? _c : '' } };
        const minLengthField = minLength && { minLength: { value: minLength, message: (_d = messages === null || messages === void 0 ? void 0 : messages.minLength) !== null && _d !== void 0 ? _d : '' } };
        const _e = register(name, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, requiredField), maxLengthField), minLengthField), validateField), patternField)), { ref: registerRef } = _e, rest = __rest(_e, ["ref"]);
        //  當props有傳入其他自定義onBlur事件
        if (onBlur) {
            return {
                registerRef,
                rest: Object.assign(Object.assign({}, rest), { onBlur: (event) => {
                        rest.onBlur(event);
                        handleOnBlur(event);
                    } })
            };
        }
        return { registerRef, rest };
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `input__wrapper  ${className} ${objectUtils_1.default.isExist(message) ? 'errorInput' : ''} ${required ? 'required' : ''}` }, { children: [objectUtils_1.default.isExist(label) && ((0, jsx_runtime_1.jsx)(Label_1.default, Object.assign({ htmlFor: name, className: `label__top ${readonly ? 'readonly' : ''} ` }, { children: label }))), (0, jsx_runtime_1.jsx)("input", Object.assign({}, (_a = getHandlerBinding()) === null || _a === void 0 ? void 0 : _a.rest, { className: readonly ? 'readonly' : '', type: type, id: name, name: name, placeholder: placeholder, onClick: handleOnClick, onChange: handleOnChange, onCompositionStart: handleComposition, onCompositionUpdate: handleComposition, onCompositionEnd: handleComposition, defaultValue: defaultValue, disabled: disabled, value: value, "data-index": dataIndex, min: minValue, ref: (_b = getHandlerBinding()) === null || _b === void 0 ? void 0 : _b.registerRef })), isShowIntervalMark && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "intervalMark" }, { children: "~" })), objectUtils_1.default.isExist(message) && (0, jsx_runtime_1.jsx)("p", { children: message })] })));
};
exports.default = InputLabel;
